import { render, staticRenderFns } from "./newAnnounceDetails.vue?vue&type=template&id=5235fc82&scoped=true&"
import script from "./newAnnounceDetails.vue?vue&type=script&lang=js&"
export * from "./newAnnounceDetails.vue?vue&type=script&lang=js&"
import style0 from "./newAnnounceDetails.vue?vue&type=style&index=0&id=5235fc82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5235fc82",
  null
  
)

export default component.exports